import request from './request';

const origin = process.env.NODE_ENV === 'production' ? location.origin : '';

const path = origin + '/accounts1/rest/hwidcenter';

export default {
  getDefaultRedirect() {
    return request.get(`${path}/get-default-redirect`);
  },
};
